import { TextStatesData, TextureStatesData } from "../../../types/types";
import { ApplyMixins } from "../../../utils/ApplyMixins";
import { Interactive } from "../../../mixins/Interactive";
import { Showable } from "../../../mixins/Showable";
import { Toggleable } from "../../../mixins/Toggleable";
import { UpdateView } from "../../../mixins/UpdateView";
import { ISize } from "../../../controls/scrollpane/ISize";
import { LoaderFileKeys } from "../../constant/AppConstants";
import { RectSize } from "../../../utils/RectSize";
import { AppSettings } from "../../managers/AppSettings";
import { Padding } from "../../../utils/Padding";


/**
 * Base classs for:
 * @see OptionsItem
 * @see ResultsItem
 * @see StatisticsItem
 */
export class SettingsItem
    extends Phaser.GameObjects.Container
    implements ISize
{
    public bg: Phaser.GameObjects.Image;
    public label: Phaser.GameObjects.Text;

    protected size: RectSize = new RectSize();
    // protected innerScale: number = 1;

    // Any settings list item: spacing between elements
    // not used in: ResultsListItem, DealsListItem (where spacing of inner elements is caluclated dynamically based on subelement size)
    protected itemSpacing: RectSize = new RectSize(20, 20);

    /**
     * Baseline padding outside of elements to the border
     * - not really used, rather, we use @see borderPadding, which considers innerScale
     */
    // protected baseBorderPadding: RectSize = {width: 40, height: 20};
    // // [cached] scaled border padding to use with scaling via innerScale
    // protected borderPadding: RectSize = {width: this.baseBorderPadding.width * this.innerScale, height: this.baseBorderPadding.height * this.innerScale};
    protected borderPadding: Padding = new Padding(30, 22);

    /**
     * @alike: OnResize
     * Uses 'maximum allowed width' to compute item's resulting height
     * - Item's width and height depends on height of label textfield
     * - label's height depends on amount of HORIZONTAL space and maximum horizontal space allowed for item
     * 
     * @param width 
     */
    public SetWidthGetHeight(width: number): number {
        return 0;

        // overwrite in subclass
    }

    // overloads
    public SetSize(width: number, height?: number): void;
    public SetSize(size: RectSize): void;
    // implementation
    public SetSize(a: any, b: any = undefined): void {
        // its (width, height) overload
        if (b != undefined) {
            this.size.Set(a, b);
        }
        // else its RectSize overload
        else {
            console.log("warning: calculation check");
            this.size = a;
        }
        this.OnResize();
    }

    /**
     * Size changed
     */
    public OnResize(): void {
        // overwrite in subclass
    }

    public GetSize(): RectSize {
        return this.size;
    }

    protected OnInteractiveChanged(newInteractive: boolean): void {
        console.log("SetingsItem::OnInteractiveChanged", newInteractive);
    }
}